import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import {SwalAlertClass} from "core/swalClass";
import ModalConfigTable from "./ModalConfigTable";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import LoaderSpinner from "context/LoaderSpinner";
import axiApi from "ApiCaller";
import ItemsModel from "core/itemsModel";
import {MQ24GPGA460Model} from "./models/MQ24GModels";

const FormatsCodes = {
    getAttr: (format) => {
        const keys = {b: "basic", a: "advanced"};
        return keys[format];
    },
    getCode: (format) => {
        const keys = {b: "0", a: "1"};
        return keys[format];
    },
};

const ModalConfigSelect = ({show, setShow, items, setItemsParent, _TC}) => {
    const {t: _Tf} = useTranslation("forms");
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const navigate = useNavigate();
    const [item, setItem] = useState({...MQ24GPGA460Model});
    const [itemsShown, setItemsShown] = useState([]);
    const configs = useRef(new ItemsModel());
    const [command, setCommand] = useState("0");
    const [isLoading, setIsLoading] = useState(false);
    const filters = useRef({searcher: ""});

    useEffect(() => {
        setIsLoading(true);
        configs.current.reset();
        setItemsShown([]);
        axiApi
            .post("/api/devices/pga/configs/")
            .then((resp) => {
                configs.current.all = [...resp.data.items];
                configs.current.showed = [...resp.data.items];
                setItemsShown([...configs.current.showed]);
            })
            .catch((error) => {
                console.error("Error fetching firmwares:", error);
            })
            .finally(() => setIsLoading(false));
    }, []);
    const onChangeCommand = (e) => {
        setCommand(e.target.value);
    };

    const handleClose = () => {
        setItem({...MQ24GPGA460Model});
        setShow(false);
    };

    const handleAccept = () => {
        if (!item.name) {
            Alert.warning(
                _TC("messages.title.select-configuration"),
                _TC("messages.content.select-configuration"),
            );
            return;
        }
        let uuids = [...items.current.chosen];
        let dataSend = {
            uuids: uuids,
            config: item.id,
            command: command,
        };
        axiApi.post("/api/devices/pga/senders/send/", dataSend).then((resp) => {
            if (resp.data.status) {
                Alert.success(
                    _TC("messages.title.send"),
                    _TC("messages.content.send") +
                        " " +
                        uuids.length +
                        " " +
                        _TC("label.devices"),
                ).then((r) => {
                    navigate(0);
                });
            } else {
                console.error("Error en el servidor", resp.data);
                Alert.error(
                    _TC("messages.title.send-error"),
                    _TC("messages.content.send-error"),
                );
            }
        });
        setShow(false);
    };
    const filterItems = () => {
        let _items = [...configs.current.all];

        if (filters.current.searcher) {
            _items = _items.filter((item_) => {
                const words = toLowCaseCleanSpaces(item_.name);
                return words.includes(filters.current.searcher);
            });
        }

        configs.current.showed = _items;
        setItemsShown([...configs.current.showed]);
    };

    const handleSearch = (e) => {
        filters.current.searcher = toLowCaseCleanSpaces(e.target.value);
        filterItems();
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                animation={true}
                scrollable={true}
                size="lg"
                aria-modal>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="paper-plane" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline me-4">
                            {_TC("label.configs")}
                        </Modal.Title>
                        <form
                            className="d-inline-flex ms-2"
                            role="search"
                            onSubmit={handleFormSubmit}>
                            <input
                                className="form-control border-end-0 rounded-0"
                                type="search"
                                placeholder="Nombre"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <span
                                className="input-group-text bg-white border-start-0 rounded-0"
                                id="basic-addon1">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                            </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div
                        className="form-ms-3 pt-2 m-auto text-center"
                        style={{width: "120px"}}>
                        <h4>{_TC("label.command")}</h4>
                        <select
                            className="form-select"
                            id="filter-status"
                            name="state"
                            aria-label={_TC("filter.select.status")}
                            value={command}
                            onChange={onChangeCommand}>
                            <option value="">{_TC("filter.select.option")}</option>
                            <option value="0">{_TC("command.0")}</option>
                            <option value="1">{_TC("command.1")}</option>
                        </select>
                    </div>
                    <div className="mb-3 h5 text-center mt-5">
                        {_TC("label.aplicated") +
                            items.current.chosen.length +
                            " " +
                            _TC("label.devices")}
                    </div>
                    <LoaderSpinner isLoading={isLoading}>
                        <ModalConfigTable
                            itemsShown={itemsShown}
                            setItem={setItem}
                            _TC={_TC}
                        />
                    </LoaderSpinner>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {_TC("label.cancel")}
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        {_TC("sender")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalConfigSelect;
